<div>
  <div>
    <button mat-raised-button color="primary" type="submit" (click)="goToLogin()" style="float: right; margin:15px;">
      {{'landing.login' |translate }}
    </button>
  </div>
  <div>
    <div class="public-textContainer">
      <div class="public-centerContainer">
        <div class="public-tag1 ">
          <app-typewriter></app-typewriter>
        </div>
        <div class="public-tag2">NIA intelligence at its best to guide you</div>
      </div>
    </div>
  </div>
  @if (loadRegister) {
    <div>
      <app-register [input]=data></app-register>
    </div>
  }
</div>
